<ag-grid-angular
    *ngIf="!showLoader && gridOptions"
    class="ag-theme-bootstrap logs-table"
    [gridOptions]="gridOptions">
</ag-grid-angular>

<div *ngIf="showLoader" class="loader-container">
    <app-loader [showLoader]="true"></app-loader>
</div>
